import React from 'react';
import { connect } from 'react-redux';
import Logo from './Logo';
import avivaLogo from './aviva-logo.svg';
import { headerMainLogoSelector } from '../../scenes/Organisation/OrganisationSelectors';

export function isBrandedLogoType(logoType) {
  const normalised = typeof logoType === 'string' ? logoType.toLowerCase() : '';
  return Boolean(normalised && normalised !== 'lmi' && normalised !== 'none');
}

function BrandedLogo({ logoType, className, width, height, alt, style }) {
  if (logoType === 'none') return null;

  if (logoType === 'aviva') {
    return (
      <img
        src={avivaLogo}
        className={className}
        width={width}
        height={height}
        alt={alt || 'Aviva'}
        style={{
          display: 'block',
          maxWidth: '100%',
          height: height || 'auto',
          boxSizing: 'border-box',
          flexShrink: 0,
          objectFit: 'contain',
          ...style,
        }}
      />
    );
  }

  return <Logo className={className} width={width} height={height} style={style} />;
}

export default connect((state) => ({
  logoType: headerMainLogoSelector(state),
}))(BrandedLogo);
